
import './App.css';
import Sorter from './SortingVisualizer/Sorter.js'


function App() {
  return (
    <Sorter/>
  );
}

export default App;
